const workspaceActionTypes = {
  SET_ACTIVE_WORKSPACE: 'SET_ACTIVE_WORKSPACE',
  FETCH_WORKSPACES_UNREAD_COUNT: 'FETCH_WORKSPACES_UNREAD_COUNT',
  SET_WORKSPACES_UNREAD_COUNT: 'SET_WORKSPACES_UNREAD_COUNT',
  UPDATE_WORKSPACE_SHIFT: 'UPDATE_WORKSPACE_SHIFT',
  UPDATE_DEFAULT_LOCATION: 'UPDATE_DEFAULT_LOCATION',
};
export default workspaceActionTypes;
